<template>
  <div>
    <b-row class="no-gutters">
      <b-col>
        <h1 class="font-weight-bold header-main text-uppercase mb-3">
          ลำดับการขนส่ง :
          {{ form.TransportId }}
        </h1>
      </b-col>
      <b-col class="text-right d-flex justify-content-end">
        <b-button variant="link" class="px-1 py-0" @click="handleRoute">
          <u class="text-purple-btn">ย้อนกลับ</u>
        </b-button>
      </b-col>
    </b-row>

    <div class="mt-2">
      <div class="p-4 bg-white box-radius">
        <b-container class="p-0 bv-example-row">
          <b-row>
            <b-col cols="6" class="my-1">
              <b-row>
                <b-col cols="4">
                  <p class="mb-0">
                    <strong> วันที่ดำเนินการขนส่ง : </strong>
                  </p>
                </b-col>
                <b-col cols="8">
                  <span class="text-gray">
                    {{ new Date(data.dateOrder) | moment($formatDateTime) }}
                  </span>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6" class="my-1">
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-right">
                    <strong> ช่องทางการสั่งซื้อ : </strong>
                  </p>
                </b-col>
                <b-col cols="4">
                  <span class="text-gray">
                    {{ data.sellerShop }}
                  </span>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6" class="my-1">
              <b-row>
                <b-col cols="4">
                  <p class="mb-0">
                    <strong> ขนส่งที่ใช้บริการ : </strong>
                  </p>
                </b-col>
                <b-col cols="8">
                  <span class="text-gray">
                    {{ data.shippingType }}
                  </span>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6" class="my-1">
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-right">
                    <strong> ป้ายทะเบียนรถ : </strong>
                  </p>
                </b-col>
                <b-col cols="4">
                  <span class="text-gray">
                    {{ data.carRegistration }}
                  </span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </div>

      <div class="p-2 mt-2 bg-white box-radius border-purple">
        <b-container class="p-0">
          <b-col class="d-flex justify-content-between" cols="12">
            <div>
              <p class="m-0">
                หลักฐานการจัดส่ง :
                <span
                  class="text-purple-btn"
                  @click="openModal(data.picture, 'หลักฐานการจัดส่ง')"
                >
                  คลิกเพื่อดูหลักฐาน
                </span>
              </p>
            </div>
            <div>
              <p class="m-0">
                ลายเซ็นต์ :
                <span
                  class="text-purple-btn"
                  @click="openModal(data.signature, 'ลายเซ็นต์')"
                >
                  คลิกเพื่อดูหลักฐาน
                </span>
              </p>
            </div>
          </b-col>
        </b-container>
      </div>

      <div class="mt-2 header-purple">
        <div>
          <p class="mb-0">
            <strong> จำนวนรายการสั่งซื้อ ( จำนวน {{ rows }} รายการ ) </strong>
          </p>
        </div>
      </div>
      <div class="p-3 bg-white">
        <b-row>
          <b-col sm="8">
            <h3 class="font-weight-bold">รายการคำสั่งซื้อ</h3>
          </b-col>
          <b-col sm="4">
            <b-input-group class="panel-input-serach">
              <b-form-input
                class="input-serach"
                placeholder="ค้นหาหมายเลขคำสั่งซื้อ"
                v-model="form.Search"
                @keyup.enter="getTransportOrder"
              ></b-form-input>
              <b-input-group-prepend>
                <span class="icon-input m-auto pr-2" @click="getTransportOrder">
                  <font-awesome-icon icon="search" />
                </span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-row>
      </div>
      <div class="px-3 bg-white">
        <b-row class="no-gutters px-3 px-sm-0">
          <b-col sm="12">
            <b-table
              responsive
              striped
              sticky-header="400px"
              class="text-center table-list"
              :fields="fields"
              :items="items"
              :busy="isBusy"
              show-empty
              empty-text="ไม่พบข้อมูล"
            >
              <template v-slot:cell(receiptNo)="data">
                <div class="table-row">
                  <span class="m-0">
                    <!-- <font-awesome-icon
                      icon="circle"
                      :class="[
                        'flag',
                        data.item.datetimeColor === 3
                          ? 'text-danger'
                          : data.item.datetimeColor === 1
                          ? 'text-success'
                          : 'text-warning',
                      ]"
                    /> -->
                    {{ data.item.receiptNo || "-" }}
                  </span>
                </div>
              </template>

              <template v-slot:cell(invoiceNo)="data">
                <div>
                  <p class="m-0">
                    {{ data.item.invoiceNo || "-" }}
                  </p>
                </div>
              </template>

              <template v-slot:cell(createdTime)="data">
                <div>
                  <p class="m-0">
                    {{
                      new Date(data.item.createdTime) | moment($formatDateTime)
                    }}
                  </p>
                </div>
              </template>

              <template v-slot:cell(paymentName)="data">
                <div>
                  <p class="m-0">
                    {{ data.item.paymentName || "-" }}
                  </p>
                </div>
              </template>

              <template v-slot:cell(trackingNo)="data">
                <div>
                  <p class="m-0">
                    {{ data.item.trackingNo || "-" }}
                  </p>
                </div>
              </template>

              <template v-slot:cell(totalProduct)="data">
                <div>
                  <p class="m-0">
                    {{ data.item.totalProduct | numeral("0,0") }}
                  </p>
                </div>
              </template>

              <!-- <template v-slot:cell(orderId)="data">
                <b-button variant="link" class="px-1 py-0">
                  <router-link
                    :to="
                      '/order/details/' +
                        data.item.orderId +
                        '?brandID=' +
                        $route.query.brandID
                    "
                    class="text-purple-1"
                  >
                    <u>ดูรายละเอียด</u>
                  </router-link>
                </b-button>
              </template> -->
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
          <b-col sm="12">
            <b-row class="px-3 pb-3">
              <b-col class="form-inline justify-content-end">
                <div class="d-sm-flex mr-3">
                  <b-pagination
                    v-model="form.Skip"
                    :total-rows="rows"
                    :per-page="form.Take"
                    class="m-md-0 page-item"
                    @change="pagination"
                  ></b-pagination>
                </div>
                <b-form-select
                  v-model="form.Take"
                  @change="hanndleChangePerpage"
                  :options="pageOptions"
                ></b-form-select>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
    <ModalImage :image="image" :text="text" />
  </div>
</template>

<script>
import ModalImage from "./components/modal/ModalPic.vue";

export default {
  name: "OrderDetails",

  components: {
    ModalImage,
  },

  data() {
    return {
      form: {
        TransportId: parseInt(this.$route.params.id),
        Search: "",
        Skip: 1,
        Take: 10,
      },

      rows: 0,

      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],

      isBusy: false,

      data: [],
      items: [],
      fields: [
        {
          key: "receiptNo",
          label: `หมายเลขบิล`,
          class: "w-100px text-nowrap",
        },
        {
          key: "invoiceNo",
          label: `หมายเลขคำสั่งซื้อ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "createdTime",
          label: `วันที่สร้างบิล`,
          class: "w-100px text-nowrap",
        },
        {
          key: "paymentName",
          label: `ช่องทางการชำระเงิน`,
          class: "w-100px text-nowrap",
        },
        {
          key: "trackingNo",
          label: `หมายเลขพัสดุ`,
          class: "w-200 text-nowrap",
        },
        {
          key: "totalProduct",
          label: `จำนวนสินค้า`,
          class: "w-100px text-nowrap",
        },
      ],

      image: "",
      text: "",
    };
  },

  mounted() {
    this.getDetailTransport();
    this.getTransportOrder();
  },
  methods: {
    getDetailTransport() {
      this.axios
        .get(`${this.$baseUrl}/Batch/Detail/Transport/${this.form.TransportId}`)
        .then((result) => {
          if (result.result == 1) {
            this.data = result.detail;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getTransportOrder() {
      this.isBusy = true;

      this.axios
        .post(`${this.$baseUrl}/Batch/Transport/Orders`, this.form)
        .then((result) => {
          if (result.result == 1) {
            this.rows = result.detail.count;
            this.items = result.detail.orders;

            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    openModal(val, text) {
      this.image = val;
      this.text = text;

      this.$bvModal.show("modal-image");
    },

    pagination() {
      this.getTransportOrder();
    },

    hanndleChangePerpage() {
      this.getTransportOrder();
    },

    hasHistory() {
      return window.history.length > 2;
    },

    handleRoute() {
      if (this.hasHistory()) this.$router.back();
      else
        this.$router.push({
          path: `/order?brandID=${this.$route.query.brandID}`,
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-gray {
  color: #bcbcbc;
}

.print-selected {
  border-color: #6f67bf;
}

.header-detail {
  .bg-white {
    height: 220px;
  }
}

.box-radius {
  border-radius: 8px;
}

.border-purple {
  border: 2px solid #7160c4;
}

.modal-link-active {
  color: #b41bb4;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
}

.modal-link-disabled {
  color: #bcbcbc;
  font-size: 14px;
  pointer-events: none;
}

.header-btn {
  font-size: 15px;
  margin-top: 12.5px;
  text-decoration: underline;
}

.text-purple-btn {
  color: #b41bb4;
  cursor: pointer;
  text-decoration: underline;
}

.text-purple-btn:hover {
  color: #7160c4;
}

.seller-image {
  height: 30px;
  width: auto;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
</style>
